var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalizzatore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.04 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e01919;}.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "localizzatore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.54,100.5c-31,0-30,30-30,30s-1,6,7,22l6,9,17,25h0l17-25,6-9c8-16,7-22,7-22s1-30-30-30",
    transform: "translate(-134 -100)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30.58,
    cy: 30.56,
    r: 17.01
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalizzatore);
export default __webpack_public_path__ + "static/media/localizzatore.cd41f5fdc5fe21c09895ae8f964da0ab.svg";
export { ForwardRef as ReactComponent };